import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './application/store';
import App from './App';
import AdminSession from './infrastructure/admin-session';
import { adminSessionStarted } from './application/features/auth/authSlice';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import CustomThemeProvider from './theme';
import './index.css';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
const container = document.getElementById('root');
const root = createRoot(container);
// Restore a strong admin session (HttpOnly cookie) before the first route decision. Without the session marker this
// resolves at once and sends nothing, so professionals and password-only sessions start exactly as before.
AdminSession.restore().then((token) => {
    if (token)
        store.dispatch(adminSessionStarted(token));
    render();
});
const render = () => root.render(_jsx(I18nextProvider, { i18n: i18n, children: _jsx(Provider, { store: store, children: _jsx(BrowserRouter, { children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(CustomThemeProvider, { children: _jsx(App, {}) }) }) }) }) }));
